import { memo } from "react";
import { PageHeader, useTheme } from "react-better-html";

import { useReduxState } from "../../utils/hooks";
import { useI18n } from "../../utils/i18n";

function Dashboard() {
   const theme = useTheme();
   const { t } = useI18n();

   const firebaseUser = useReduxState((state) => state.user.firebaseUser);

   return firebaseUser ? (
      <>
         <PageHeader
            title={`${t((l) => l.pages.dashboard.title)}, ${firebaseUser.displayName?.split(" ")[0] ?? ""}`}
            description={t((l) => l.pages.dashboard.description)}
            titleAs="h2"
            marginBottom={theme.styles.space}
         />
      </>
   ) : undefined;
}

export default memo(Dashboard);
